import React from 'react';
import { NavLink } from 'react-router-dom';
import avatar from '../../assets/img/avatars/avatar.png';
import { useSidebar } from '../../context/SidebarContext';
const Header = () => {
  const cms_sub_domain = localStorage.getItem('cms_sub_domain');
  const logOut = () => {
    localStorage.removeItem('token');
    window.location.href = '/login';
  }
  const { toggleSidebar } = useSidebar();
  return (
    <nav className="navbar navbar-expand navbar-light navbar-bg">
      <NavLink className="sidebar-toggle js-sidebar-toggle" onClick={toggleSidebar}>
        <i className="hamburger align-self-center"></i>
      </NavLink>
      <h3>{cms_sub_domain?`${cms_sub_domain}.scientexconference.com`:""}</h3>
      
      {/* <ul className="navbar-nav d-none d-lg-flex">
        <li className="nav-item dropdown">
          <NavLink
            className="nav-link dropdown-toggle"
            to="/"
            id="resourcesDropdown"
            role="button"
            data-bs-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            Resources
          </NavLink>
          <div className="dropdown-menu" aria-labelledby="resourcesDropdown">
            <NavLink
              className="dropdown-item"
              to="https://sample.com/"
              target="_blank"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-home align-middle me-1" > <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path> <polyline points="9 22 9 12 15 12 15 22"></polyline> </svg>
              Homepage
            </NavLink>
            <NavLink
              className="dropdown-item"
              to="https://sample.com/docs/"
              target="_blank"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-book-open align-middle me-1" > <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path> <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path> </svg>
              Documentation
            </NavLink>
            <NavLink
              className="dropdown-item"
              to="https://sample.com/docs/getting-started/changelog/"
              target="_blank"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-edit align-middle me-1" > <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path> <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path> </svg>
              Changelog
            </NavLink>
          </div>
        </li>
      </ul> */}

      <div className="navbar-collapse collapse">
        <ul className="navbar-nav navbar-align">
          <li className="nav-item dropdown">
          <NavLink
            className="nav-icon pe-md-0 dropdown-toggle show"
            to="#"
            data-bs-toggle="dropdown"
            aria-expanded="true"
          >
        <img src={avatar} className="avatar img-fluid rounded" alt="John Doe" />
      </NavLink>
      <div className="dropdown-menu dropdown-menu-end" data-bs-popper="static">
        <NavLink to="/" className="dropdown-item">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-user align-middle me-1" > <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path> <circle cx="12" cy="7" r="4"></circle> </svg>
          Profile
        </NavLink>
        <NavLink to="/" className="dropdown-item">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-help-circle align-middle me-1" > <circle cx="12" cy="12" r="10"></circle> <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path> <line x1="12" y1="17" x2="12.01" y2="17"></line> </svg>
          Help Center
        </NavLink>
        <button className="dropdown-item" type="button" onClick={logOut}>
          Log out
        </button>
      </div>
    </li>
        </ul>
      </div>
    </nav>
  );
};

export default Header;